import React from 'react'
import { listVisionsByTimelineRootId, type VisionItem } from '../services/visionService'

type UseTimelineVisionsResult = {
  items: VisionItem[]
  loading: boolean
  error: string | null
}

export function useTimelineVisions(
  timelineRootId: number | null,
  enabled: boolean,
): UseTimelineVisionsResult {
  const [items, setItems] = React.useState<VisionItem[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!enabled || timelineRootId == null) {
      setItems([])
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    listVisionsByTimelineRootId({ timelineRootId })
      .then((next) => {
        if (!active) return
        setItems(next || [])
      })
      .catch((e: any) => {
        if (!active) return
        setItems([])
        setError(e?.message || 'Falha ao carregar historico de visoes')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, timelineRootId])

  return { items, loading, error }
}
